// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

require("babel-polyfill")
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment'
// import iviewArea from 'iview-area'
import 'iview/dist/styles/iview.css'
import "./assets/stylesheets/app.scss"
import store from './store'
// Vue.use(iviewArea)
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

// 切换语言
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
import {language, getLocalLanguage} from './utils/language'

const i18n = new VueI18n({
    locale: getLocalLanguage('en'),
    messages: language
})


Vue.use(VueAwesomeSwiper, /* { default global options } */)

window.moment = moment
// window.pwdRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[\`\~\!\@\#\$\%\^\&\*\(\)_\+\-\=\{\}\|\[\]\:\;\'\<\>\?\,\.]).{8,}$/

Vue.config.productionTip = false
Vue.prototype.Copyright = 'Copyright ® 深圳市领存技术有限公司 | 粤ICP备17069059号'

switch (process.env.NODE_ENV) {
    case 'production':
        Vue.prototype.url = 'https://storlead.com'
        Vue.prototype.testUrl = 'https://nandflashtest.storlead.com'
        Vue.prototype.mainUrl = 'https://nandflashtest.storlead.com'
        Vue.prototype.labMainUrl = 'https://lab.storlead.com/'
        break
    default:
        Vue.prototype.url = 'https://test1.storlead.com/'
        Vue.prototype.labMainUrl = 'https://lab.test.storlead.com/'
        // Vue.prototype.testUrl = 'https://test.storlead.com/sltp'
        // Vue.prototype.mainUrl = 'https://test.storlead.com/sltp'
        Vue.prototype.testUrl = 'https://sltptest.storlead.com'
        Vue.prototype.mainUrl = 'https://sltptest.storlead.com'
        break
}

/**/
// import download from './utils/download'
// Vue.prototype.download = download.download
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {App},
    template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js